const PDF_PAGE_SELECTOR = '[data-pdf-page-wrapper="true"]';

const getPageNumber = (pageWrapper) => {
  const pageNumber = Number(pageWrapper?.dataset?.pdfPageNumber);
  return Number.isInteger(pageNumber) && pageNumber > 0 ? pageNumber : null;
};

/**
 * Capture the page around the viewport midpoint instead of only scrollTop.
 * Page dimensions can change after a PDF rotation, so an absolute scrollTop
 * is not enough to keep the same document position visible.
 */
export const capturePdfScrollAnchor = (scrollContainer) => {
  if (!scrollContainer) {
    return null;
  }

  const pageWrappers = Array.from(scrollContainer.querySelectorAll(PDF_PAGE_SELECTOR));
  if (!pageWrappers.length) {
    return null;
  }

  const containerRect = scrollContainer.getBoundingClientRect();
  const viewportMidpoint = containerRect.top + (containerRect.height / 2);
  const visiblePage = pageWrappers.find((pageWrapper) => {
    const pageRect = pageWrapper.getBoundingClientRect();
    return pageRect.top <= viewportMidpoint && pageRect.bottom >= viewportMidpoint;
  }) || pageWrappers.find((pageWrapper) => (
    pageWrapper.getBoundingClientRect().bottom > containerRect.top
  )) || pageWrappers[0];
  const pageNumber = getPageNumber(visiblePage);

  if (!pageNumber) {
    return null;
  }

  return {
    pageNumber,
    offsetTop: visiblePage.getBoundingClientRect().top - containerRect.top,
    scrollLeft: scrollContainer.scrollLeft,
  };
};

export const restorePdfScrollAnchor = (scrollContainer, anchor) => {
  if (!scrollContainer || !anchor) {
    return false;
  }

  const targetPage = Array.from(scrollContainer.querySelectorAll(PDF_PAGE_SELECTOR))
    .find((pageWrapper) => getPageNumber(pageWrapper) === anchor.pageNumber);
  if (!targetPage) {
    return false;
  }

  const containerRect = scrollContainer.getBoundingClientRect();
  const currentOffsetTop = targetPage.getBoundingClientRect().top - containerRect.top;
  const desiredOffsetTop = Number(anchor.offsetTop);
  if (!Number.isFinite(desiredOffsetTop)) {
    return false;
  }

  scrollContainer.scrollTop += currentOffsetTop - desiredOffsetTop;
  if (Number.isFinite(Number(anchor.scrollLeft))) {
    scrollContainer.scrollLeft = Number(anchor.scrollLeft);
  }
  return true;
};
